export default "__VITE_ASSET__zufCKVhvnneTXSZvm7iDtg__"